/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Pokud již máte účet, prosím přihlaste se.`
};

const da_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Hvis du allerede har en konto, så log ind.`
};

const de_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Wenn Sie bereits ein Konto haben, melden Sie sich bitte an.`
};

const en_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `If you have an account with us, please log in.`
};

const es_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Si ya tienes una cuenta, por favor inicia sesión.`
};

const fr_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Si vous avez déjà un compte, veuillez vous identifier.`
};

const hu_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Ha már van fiókom, kérjük, jelentkezz be.`
};

const it_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Se hai già un account, effettua l'accesso.`
};

const nl_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Log in als je al een account hebt.`
};

const pl_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Jeśli masz już konto, zaloguj się.`
};

const pt_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Se você já tem uma conta, faça login.`
};

const sv_account_login_subtitle = /** @type {(inputs: {}) => string} */ () => {
	return `Om du redan har ett konto, logga in.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_login_subtitle = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_login_subtitle(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_login_subtitle", locale)
	if (locale === "cs") return cs_account_login_subtitle(inputs)
	if (locale === "da") return da_account_login_subtitle(inputs)
	if (locale === "de") return de_account_login_subtitle(inputs)
	if (locale === "en") return en_account_login_subtitle(inputs)
	if (locale === "es") return es_account_login_subtitle(inputs)
	if (locale === "fr") return fr_account_login_subtitle(inputs)
	if (locale === "hu") return hu_account_login_subtitle(inputs)
	if (locale === "it") return it_account_login_subtitle(inputs)
	if (locale === "nl") return nl_account_login_subtitle(inputs)
	if (locale === "pl") return pl_account_login_subtitle(inputs)
	if (locale === "pt") return pt_account_login_subtitle(inputs)
	return sv_account_login_subtitle(inputs)
};
export { account_login_subtitle as "account.login_subtitle" }